<template>
  <div>
    <div
        id="iona-settings"
        @click="handleButtonClick">
      <b-img
          v-if="ionaActive"
          v-bind="mainPropsTopBar"
          rounded="circle"
          src="@/assets/iona/img/iona_on.png"
          alt="IONA (Insightful Omnipresent Nurturing Ant) Active"
      />
      <b-img
          v-else
          v-bind="mainPropsTopBar"
          rounded="circle"
          src="@/assets/iona/img/iona_off.png"
          alt="IONA (Insightful Omnipresent Nurturing Ant) InActive"
      />
    </div>
    <b-popover
        ref="popover"
        target="iona-settings"
        :triggers="triggers"
        :show.sync="popoverShow"
        placement="auto"
        container="my-container"
        :delay="{ show: 1500, hide: 400 }"
        @show="onShow"
        @shown="onShown"
        @hidden="onHidden"
    >
      <template #title>
        <b-button @click="onClose" class="close" aria-label="Close">
          <span class="d-inline-block" aria-hidden="true">&times;</span>
        </b-button>
        Iona Settings
      </template>
      <div>
        <!-- Turn Iona on and Off-->
        <toggle-single
            id="iona-active-toggle"
            :toggle-model="ionaActive"
            :label-name="`Iona is ${ionaActive ? 'Active' : 'Inactive'}`"
            label-info=""
            @toggle-click="handleToggleActive"
        />

        <template v-if="false">
          <b-form-group
              label="Name"
              label-for="popover-input-1"
              label-cols="3"
              :state="input1state"
              class="mb-1"
              description="Enter your name"
              invalid-feedback="This field is required"
          >
            <b-form-input
                ref="input1"
                id="popover-input-1"
                v-model="input1"
                :state="input1state"
                size="sm"
            ></b-form-input>
          </b-form-group>
          <b-form-group
              label="Color"
              label-for="popover-input-2"
              label-cols="3"
              :state="input2state"
              class="mb-1"
              description="Pick a color"
              invalid-feedback="This field is required"
          >
            <b-form-select
                id="popover-input-2"
                v-model="input2"
                :state="input2state"
                :options="options"
                size="sm"
            ></b-form-select>
          </b-form-group>
          <b-alert show class="small">
            <strong>Current Values:</strong><br>
            Name: <strong>{{ input1 }}</strong><br>
            Color: <strong>{{ input2 }}</strong>
          </b-alert>
          <b-button
              v-if="false"
              @click="onClose"
              size="sm"
              variant="danger">
            Cancel
          </b-button>
        </template>

        <b-button
            variant="primary btn-round-fill"
            @click="onOk"
            size="sm">
          &nbsp;Save&nbsp;
        </b-button>
      </div>
    </b-popover>
  </div>
</template>

<script>
import toggleSingle from "@/components/common/toggleSingle";
export default {
  name: "notifications-menu",
  components: {
    toggleSingle
  },
  computed: {
  },
  methods: {
    handleToggleActive() {
      this.ionaActive = !this.ionaActive;
    },
    handleButtonClick(){
        this.$emit('button-click');
    },
    onClose() {
      this.popoverShow = false;
    },
    onOk() {
      if (!this.input1) {
        this.input1state = false;
      }
      if (!this.input2) {
        this.input2state = false;
      }
      if (this.input1 && this.input2) {
        this.onClose()
        // Return our popover form results
        this.input1Return = this.input1;
        this.input2Return = this.input2;
      }
    },
    onShow() {
      // This is called just before the popover is shown
      // Reset our popover form variables
      this.input1 = '';
      this.input2 = '';
      this.input1state = null;
      this.input2state = null;
      this.input1Return = '';
      this.input2Return = '';
    },
    onShown() {
      // Called just after the popover has been shown
      // Transfer focus to the first input
      this.focusRef(this.$refs.input1);
    },
    onHidden() {
      // Called just after the popover has finished hiding
      // Bring focus back to the button
      this.focusRef(this.$refs.button);
    },
    focusRef(ref) {
      // Some references may be a component, functional component, or plain element
      // This handles that check before focusing, assuming a `focus()` method exists
      // We do this in a double `$nextTick()` to ensure components have
      // updated & popover positioned first
      this.$nextTick(() => {
        this.$nextTick(() => {
          ;(ref.$el || ref).focus();
        })
      })
    }
  },
  watch: {
    input1(val) {
      if (val) {
        this.input1state = true;
      }
    },
    input2(val) {
      if (val) {
        this.input2state = true;
      }
    }
  },
  mounted() {},
  data() {
    return {
      triggers:'',
      ionaActive: true,
      input1: '',
      input1state: null,
      input2: '',
      input2state: null,
      options: [
        {
          text: '- Choose 1 -',
          value: ''
        },
        'Red',
        'Green',
        'Blue'
      ],
      input1Return: '',
      input2Return: '',
      popoverShow: false,
      mainPropsTopBar: {
        blank: false,
        blankColor: '#fcc727',
        width: 25,
        height: 25,
        class: 'm1'
      },
      form:{
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
